import { createRoot } from "react-dom/client";
import * as Sentry from '@sentry/react';
import App from "./App";
import "./embed";
import { BrowserRouter } from 'react-router-dom';
import { applyErrorBoundary } from './error/ApplyErrorBoundary';

Sentry.init({
  dsn: "https://178ad3220f151975d84bd7c8fb6f0a0d@o4510466694447104.ingest.us.sentry.io/4510991707013120",
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
  environment: process.env.NODE_ENV,
});

const ProtectedApp = applyErrorBoundary(App);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ProtectedApp />
  </BrowserRouter>
);